
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 477.827 477.827"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M441.537 160.632a132.848 132.848 0 002.253-24.201C443.699 61.026 382.498-.028 307.093.062c-57.402.069-108.63 36.034-128.194 89.999-35.029-13.944-74.73 3.148-88.675 38.177a68.201 68.201 0 00-2.956 9.319c-55.932 8.365-94.492 60.488-86.127 116.42 7.502 50.163 50.596 87.275 101.316 87.254h85.333c9.426 0 17.067-7.641 17.067-17.067s-7.641-17.067-17.067-17.067h-85.333c-37.703 0-68.267-30.564-68.267-68.267s30.564-68.267 68.267-68.267c9.426 0 17.067-7.641 17.067-17.067.031-18.851 15.338-34.108 34.189-34.077a34.135 34.135 0 0123.837 9.757c6.713 6.616 17.519 6.537 24.135-.176a17.066 17.066 0 004.69-9.245c9.264-55.733 61.954-93.403 117.687-84.139 55.733 9.264 93.403 61.954 84.139 117.687a102.27 102.27 0 01-2.146 9.869 17.066 17.066 0 007.049 18.773c31.416 20.845 39.985 63.212 19.139 94.628a68.264 68.264 0 01-56.72 30.522h-51.2c-9.426 0-17.067 7.641-17.067 17.067s7.641 17.067 17.067 17.067h51.2c56.554-.053 102.357-45.943 102.303-102.497a102.394 102.394 0 00-36.289-78.1z"}}),_c('path',{attrs:{"d":"M353.456 243.832l-85.333-85.333a16.871 16.871 0 00-5.564-3.703 17.064 17.064 0 00-13.039 0 16.913 16.913 0 00-5.564 3.703l-85.333 85.333c-6.548 6.78-6.36 17.584.42 24.132 6.614 6.387 17.099 6.387 23.712 0l56.235-56.201v248.934c0 9.426 7.641 17.067 17.067 17.067s17.067-7.641 17.067-17.067V211.764l56.201 56.201c6.78 6.548 17.584 6.36 24.132-.42 6.387-6.614 6.387-17.1-.001-23.713z"}})])
          )
        }
      }
    